import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import { API } from '../api';

const useReCArticles = ({
  grpId,
  location,
  orgId,
  userId,
  levelId,
  taskId
}: {
  grpId: string;
  location: string;
  orgId: string;
  userId: string;
  levelId: string;
  taskId: string;
}) => {
  return useQuery({
    queryKey: [queryKeys.GET_REC_ARTICLES, grpId, orgId, userId],
    queryFn: () => {
      return API.getRecommendedArticles({ grpId, location, orgId, userId, levelId, taskId });
    },
    staleTime: 10 * 10 * 1000
  });
};

export default useReCArticles;
